<!-- FORGOT password FORM -->

<div  id="fgpwd"  class="page-wrapper bg-gra-01">
  <div class="wrapper wrapper--w790">
      <div class="card card-5">
          <div class="card-heading">
              <h2 class="title">Forgot Password Form</h2>
          </div>

  <!-- ng if for forgot password -->


  <div style="border-radius: 10px;overflow: hidden;">
    <form
    #forgotPwdForm="ngForm"
    (ngSubmit)="forgotPwdForm.valid && onSubmit(forgotPwdForm)"
    >
        <!-- starting card body -->
        <div class="card-body">
            <div class="alert" *ngIf="serverErrorMessages=='User not found'">
                <span>{{serverErrorMessages}}</span>
            </div>
            <div class="alert" *ngIf="serverErrorMessages=='OTP already sent'">
                <span>{{serverErrorMessages}}. If not received, then please try again in 5 minutes.</span>
            </div>
            <div class="alert" *ngIf="successMessage">
                <span>{{successMessage}}</span>
            </div>
            <div class="form-row">
                
                <div class="name" style="font-weight: bolder; font-size:large;">USER NAME</div>
                <div class="col-6">
                <div class="value">
                    <div class="input-group">
                    <input class="input--style-5"
                      type="text"
                      #userName="ngModel"
                      class="form-control"
                      (ngModel)="userName"
                      name="userName"
                      required
                      [ngClass]="{ 'invalid-textbox': forgotPwdForm.submitted && !userName.valid }"
                    />
                    <div *ngIf="forgotPwdForm.submitted && userName.errors">
                      <label *ngIf="userName.errors.required" class="validation-message">
                      This field is required.
                      </label>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            <div>
                <input type="submit"class="btn btn-primary" style="padding:8px;" value="Request OTP"/>
            </div>


        </div>
        <!-- end card body -->

    </form>

</div>



<!-- ng container for forgot password -->
</div>
</div>
</div>
